<template>
<div>
    <Breadcrumbs main="Project" submain="Vendor" title="Project Details" />

    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header title-button-container">
                        <div style="display: flex; flex-direction: column; gap: 10px;">
                            <div style="display: flex; flex-direction: row; gap: 10px;">
                                <h5>{{ details.title }}</h5>

                            </div>

                        </div>

                    </div>

                    <div class="card-body">
                        <div v-html="details.details"></div>

                        <div>
                            <div class="row">
                                <div class="mt-4 col col-lg-8">

                                    <div style="display: flex; flex-direction: row; align-items: center; margin-top: 4px;">
                                        <div style="width: 140px;">
                                            <span>Priority</span>
                                        </div>
                                        <span v-if="details.priority == 'MEDIUM'" class="badge" :class="'badge-primary'">{{ details.priority }}</span>
                                        <span v-if="details.priority == 'LOW'" class="badge" :class="'badge-danger'">{{ details.priority }}</span>
                                        <span v-if="details.priority == 'HIGH'" class="badge" :class="'badge-success'">{{ details.priority }}</span>
                                    </div>

                                    <div style="display: flex; flex-direction: row; align-items: center; margin-top: 4px;">
                                        <div style="width: 140px;">
                                            <span>Start Date</span>
                                        </div>
                                        <div style="font-size: medium;">{{ details.start_date }}</div>
                                    </div>

                                    <div style="display: flex; flex-direction: row; align-items: center; margin-top: 4px;">
                                        <div style="width: 140px;">
                                            <span>Deadline</span>
                                        </div>
                                        <div style="font-size: medium;">{{ details.deadline }}</div>
                                    </div>

                                    <!-- <div style="display: flex; flex-direction: row; align-items: center; margin-top: 4px; margin-bottom: 4px;">
                                        <div style="width: 140px;">
                                            <span>Project Lead</span>

                                        </div>

                                    </div> -->

                                </div>
                                <div class="mt-4 col col-lg-4">
                                    <div>
                                        <div class="d-flex justify-content-between ">
                                            <h6 class="mb-3">Supporting Documents</h6>
                                        </div>
                                        <div class="table-responsive datatable-vue">

                                            <b-table show-empty sticky-header :items="details.project_attach" :fields="projectAttachment" head-variant="light">
                                                <template #cell(index)="data">
                                                    {{ (currentPage - 1) * perPage + data.index + 1 }}
                                                </template>

                                                <template #cell(title)="data">
                                                    <a :href="host+data.item.project_attachment">{{ truncateText(data.item.attach_title, 20) }}</a>
                                                </template>

                                            </b-table>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <div style="display: flex; flex-direction: row; gap: 10px; cursor: pointer;">

                            <h7 @click="toggleItem('Po')" :class="{ active: activeItem === 'Po' }">Purchase Order</h7>
                            <h7 @click="toggleItem('Bill')" :class="{ active: activeItem === 'Bill' }">Bill</h7>

                        </div>
                    </div>

                    <div class="card" v-if="activeItem === 'Po'">

                        <div class="card-body">
                            <b-row>
                                <b-col xl="6">

                                    <b-input-group class="datatable-btn">
                                        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                        <b-input-group-append>
                                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                        </b-input-group-append>
                                    </b-input-group>

                                </b-col>

                                <b-col xl="6">
                                    <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                        <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>

                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="po_list" :fields="tablefieldsPurchaseOrder" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                  <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>
                                    <template #cell(purchase_order_id)="data">
                                        <span>
                                            <router-link :to="`/procurement/purchase-order/${data.item.id}`" class="link-style">
                                                {{ data.item.purchase_order_id }}
                                            </router-link>
                                        </span>
                                    </template>
                                    <template #cell(subtotal)="data">
                                        <span>
                                            {{ data.item.subtotal }} {{ data.item.currency }}
                                        </span>
                                    </template>
                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 0.5rem;" v-if="data.item.vendor_status === 'PENDING'">
                                            <b-button variant="outline-secondary" size="sm" @click="acceptPO(data.item.id)" v-b-modal.modal-center-accept>Accept</b-button>
                                            <b-button variant="outline-danger" size="sm" @click="rejectPO(data.item.id)" v-b-modal.modal-center-reject>Reject</b-button>
                                        </span>
                                        <span style="display: flex; gap: 0.5rem;" v-else-if="data.item.vendor_status === 'ACCEPTED'">
                                            <b-button variant="success" size="sm" disabled>Accepted</b-button>
                                        </span>
                                        <span style="display: flex; gap: 0.5rem;" v-else-if="data.item.vendor_status === 'REJECTED'">
                                            <b-button variant="danger" size="sm" disabled>Rejected</b-button>
                                        </span>
                                    </template>

                                </b-table>
                            </div>

                            <b-col md="6" class="my-1 p-0">
                                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                            </b-col>
                        </div>
                    </div>
                    <div class="card" v-if="activeItem === 'Bill'">
                        <div class="card-body">
                            <b-row>
                                <b-col xl="6">

                                    <b-input-group class="datatable-btn">
                                        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                        <b-input-group-append>
                                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                        </b-input-group-append>
                                    </b-input-group>

                                </b-col>

                                <b-col xl="6">
                                    <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                        <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>

                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="bill_list" :fields="tablefieldsBill" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">

                                   <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>
    
                                    <template #cell(bill_id)="data">
                                        <span>
                                             <router-link :to="`/procurement/bill/${data.item.id}`" class="link-style">
                                            {{ data.item.bill_id }}
                                             </router-link>
                                        </span>
                                    </template>
    
                                    <template #cell(raised_by)="data">
                                        <span v-if="data.item.created_by.username">
                                           
                                                {{ data.item.created_by.username }}
                                            
                                        </span>
                                        <span v-else>
                                            <router-link :to="`/finance-and-accounts/finance/bill/${data.item.id}`" class="link-style">
                                                <p>--</p>
                                            </router-link>
    
                                        </span>
                                    </template>
    
                                    <template #cell(subtotal)="data">
                                        <!-- <span>
                                            {{ data.item.subtotal }} {{ data.item.currency }}
                                        </span> -->
    
                                        <div class="d-flex flex-column" style="width: 150px;">
                                            <span class="font-weight-bold">Total: {{ data.item.subtotal }}</span>
                                            <span><span class="text-success font-weight-bold">Paid:</span> {{ data.item.paid_amount }}</span>
                                            <span><span class="text-danger font-weight-bold">Due:</span> {{ data.item.due_amount }}</span>
                                        </div>
                                    </template>
    
                                    <template #cell(status)="row">
    
                                        <span v-if="row.value == 'APPROVED'">
                                            <b-badge variant="success">{{ row.value }}</b-badge>
                                        </span>
                                        <span v-if="row.value == 'PENDING'">
                                            <b-badge variant="primary">{{ row.value }}</b-badge>
                                        </span>
                                        <span v-if="row.value == 'DUE'">
                                            <b-badge variant="danger">{{ row.value }}</b-badge>
                                        </span>
                                    </template>
                                </b-table>
                            </div>

                            <b-col md="6" class="my-1 p-0">
                                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                            </b-col>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import {
    myHost
} from "../../../../_helpers/host";
export default {
    data() {
        return {
            host: myHost.host,
            activeItem: 'Po',

            tablefieldsPurchaseOrder: [{ key: 'index', label: '#' },
                { key: 'purchase_order_id', label: 'Purchase Order ID', sortable: true },
                { key: 'email', label: 'Email', sortable: true },
                { key: 'purchase_order_date', label: 'Purchase Order Date', sortable: true },
                { key: 'due_date', label: 'Due Date', sortable: true },
                { key: 'subtotal', label: 'Grand Total', sortable: true },
                { key: 'action', label: 'Action', sortable: false }

            ],
            tablefieldsBill: [{
                        key: 'index',
                        label: '#'
                    },
                    {
                        key: 'bill_id',
                        label: 'Bill ID',
                        sortable: true
                    },
                    {
                        key: 'raised_by',
                        label: 'Raised By',
                        sortable: true
                    },
                    {
                        key: 'email',
                        label: 'Email',
                        sortable: true
                    },
                    {
                        key: 'subtotal',
                        label: 'Amount',
                        sortable: true
                    },
                    {
                        key: 'bill_date',
                        label: 'Bill Date',
                        sortable: true
                    },
                    {
                        key: 'due_date',
                        label: 'Due Date',
                        sortable: true
                    },
                    {
                        key: 'status',
                        label: 'Status',
                        sortable: true
                    },

            ],
            projectAttachment: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'title',
                    label: 'Title',
                    sortable: false
                },

            ],

            filter: null,

            totalRows: 1,
            currentPage: 1,
            perPage: 25,
            pageOptions: [25, 50, 100],

        };
    },
    computed: {
        ...mapState({
            details: state => state.vendor.vendor_project_detail,
            po_list: state => state.vendor.vendor_po_by_project,
            bill_list: state => state.vendor.vendor_bill_by_project

        }),

        sortOptions() {
            return this.tablefields
            s.filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
        },
        user_id() {
            return this.user?.user_object?.id;
        },

    },
    mounted() {
        this.$store.dispatch("vendor/fetchVendorProjectDetails", this.$route.params.id).then(() => {
            this.$store.dispatch("vendor/fetchVendorPurchaseOrderbyProject", {
                project: this.details.id,
                vendor: this.user_id
            })
            this.$store.dispatch("vendor/fetchVendorBillbyProject",{
                project: this.details.id,
                vendor: this.user_id
            })
        });

    },
    created(){
        this.user = JSON.parse(localStorage.getItem('user'));
    },
    methods: {
        truncateText(text, maxLength) {
            if (text.length > maxLength) {
                return text.substring(0, maxLength) + '...';
            } else {
                return text;
            }
        },
        toggleItem(item) {
            this.activeItem = item;
        },
    }
}
</script>

<style scoped>
.active {
    color: #ff595d;
}
</style>
